/**
 * DATX Asset & Image URL Resolver
 * Resolves local, relative, and production media URLs automatically.
 */
export const formatImageUrl = (url, fallback = 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200') => {
  if (!url) return fallback;

  // Base64 and Blob
  if (typeof url === 'string' && (url.startsWith('data:') || url.startsWith('blob:'))) {
    return url;
  }

  const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  // Backend host where uploads are stored
  const backendBaseUrl = isLocalhost ? 'http://localhost:5000' : 'https://api.datxsci.com';

  let formatted = String(url).trim();

  // If saved with localhost:5000 or 127.0.0.1:5000 but the app is in production
  if (formatted.includes('localhost:5000') || formatted.includes('127.0.0.1:5000')) {
    if (!isLocalhost) {
      formatted = formatted.replace(/https?:\/\/(localhost|127\.0\.0\.1):5000/, backendBaseUrl);
    }
  }

  // If relative upload path (/uploads/...)
  if (formatted.startsWith('/uploads/') || formatted.startsWith('uploads/')) {
    const cleanPath = formatted.startsWith('/') ? formatted : `/${formatted}`;
    formatted = `${backendBaseUrl}${cleanPath}`;
  }

  // Optimize Unsplash images for WebP and responsive compression
  if (formatted.includes('images.unsplash.com') && !formatted.includes('auto=format')) {
    const separator = formatted.includes('?') ? '&' : '?';
    formatted = `${formatted}${separator}auto=format&fit=crop&q=80`;
  }

  return formatted;
};

export default formatImageUrl;
